// import React, { useContext, useState, useEffect } from 'react';
// import { Save, X, ArrowLeft, User, Mail, Phone, Lock, UserPlus, UserCheck2Icon } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import AuthContext from '../../../../context/AuthContext';
// import { useToast } from '../../../../context/ToastContext';
// import Loader from '../../../../components/Loader';
// import userService from '../../../../services/userService';


// export default function AddUser() {
//   const { user,hasRole, authTokens } = useContext(AuthContext);
//   const { showError, showSuccess } = useToast();
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     contact: '',
//     email: '',
//     role_function:'',
//     password: '',
//     confirmPassword: ''
//   });

//   const [errors, setErrors] = useState({});
//   const [isLoading, setIsLoading] = useState(false);
//   const [loadingMessage, setLoadingMessage] = useState('');



//   // Clear errors when component unmounts
//   useEffect(() => {
//     return () => {
//       setErrors({});
//     };
//   }, []);

//   const handleInputChange = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       [field]: value
//     }));
    
//     // Clear error when user starts typing
//     if (errors[field]) {
//       setErrors(prev => ({
//         ...prev,
//         [field]: ''
//       }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
    
//     if (!formData.firstName.trim()) {
//       newErrors.firstName = 'Le prénom est requis';
//     }
    
//     if (!formData.lastName.trim()) {
//       newErrors.lastName = 'Le nom de famille est requis';
//     }
    
//     if (!formData.email.trim()) {
//       newErrors.email = 'L\'email est requis';
//     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Format d\'email invalide';
//     }
    
//     if (!formData.contact.trim()) {
//       newErrors.contact = 'Le contact est requis';
//     }

//     if (!formData.role_function.trim()) {
//       newErrors.role_function = 'Le role est requis';
//     }
    
//     if (!formData.password) {
//       newErrors.password = 'Le mot de passe est requis';
//     } else if (formData.password.length < 6) {
//       newErrors.password = 'Le mot de passe doit contenir au moins 6 caractères';
//     }
    
//     if (formData.password !== formData.confirmPassword) {
//       newErrors.confirmPassword = 'Les mots de passe ne correspondent pas';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };



//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) return;

//     // Check admin and organization permissions
//     if (!user || !authTokens?.access || !user.organization || !hasRole("Admin")) {
//       showError("Vous n'avez pas les droits nécessaires pour créer un utilisateur.");
//       return;
//     }

//     // Start loading
//     setIsLoading(true);
//     setLoadingMessage('Création de l\'utilisateur en cours...');

//     try {
//       // Prepare user data
//       const newUserData = {
//         first_name: formData.firstName,
//         last_name: formData.lastName,
//         contact: formData.contact,
//         email: formData.email,
//         role_function: formData.role_function,
//         password: formData.password
//       };

//       // Call the service
//       const result = await userService.createUser(newUserData, authTokens.access);
//       console.log(result)

//       if(!result.ok){
//         showError(result.error);
//       }

//       if (result.success) {
//         console.log('User created successfully:', result.data);
        
//         // Show success message
//         showSuccess('Utilisateur créé avec succès !');

//         // Reset form after success
//         setFormData({
//           firstName: '',
//           lastName: '',
//           contact: '',
//           email: '',
//           role_function:'',
//           password: '',
//           confirmPassword: ''
//         });
//         setErrors({});

//         // Navigate back to user management after a short delay
//         setTimeout(() => {
//           navigate('/dashboard/admin/users'); // Adjust this path as needed
//         }, 2000);

//       } else {
//         console.error('Error creating user:', result.errorData);
        
//         // Handle different error types
//         let errorMessage = 'Erreur lors de la création de l\'utilisateur';
        
//         if (result.status === 400) {
//           // Handle validation errors from backend
//           if (result.errorData && typeof result.errorData === 'object') {
//             // Check for specific field errors
//             if (result.errorData.email) {
//               errorMessage = `Email: ${Array.isArray(result.errorData.email) ? result.errorData.email[0] : result.errorData.email}`;
//             } else if (result.errorData.password) {
//               errorMessage = `Mot de passe: ${Array.isArray(result.errorData.password) ? result.errorData.password[0] : result.errorData.password}`;
//             } else if (result.errorData.detail) {
//               errorMessage = result.errorData.detail;
//             }
//           }
//         } else if (result.status === 403) {
//           errorMessage = result.error || 'Vous n\'avez pas les droits nécessaires pour cette action';
//         } else if (result.status === 401) {
//           errorMessage = result.error || 'Session expirée. Veuillez vous reconnecter';
//         } else if (result.status === 500) {
//           errorMessage = result.error || 'Erreur de connexion. Vérifiez votre connexion internet';
//         } else if (result.status === 0) {
//           errorMessage =  result.error || 'Erreur de connexion. Vérifiez votre connexion internet';
//         }
        
//         showError(errorMessage);
//       }

//     } catch (error) {
//       console.error('Unexpected error:', error);
//       showError("Erreur inattendue. Veuillez réessayer.");
//     } finally {
//       setIsLoading(false);
//       setLoadingMessage('');
//     }
//   };

//   const handleCancel = () => {
//     setFormData({
//       firstName: '',
//       lastName: '',
//       contact: '',
//       email: '',
//       role_function:'',
//       password: '',
//       confirmPassword: ''
//     });
//     setErrors({});
//     navigate('/dashboard/admin/users'); // Adjust this path as needed
//   };

//   return (
//     <>
//       {/* Loader overlay */}
//       <Loader 
//         isVisible={isLoading}
//         message={loadingMessage}
//         type="creation"
//         variant="spinner"
//         size="medium"
//         overlay={true}
//       />

//       <div className="space-y-6">
//         {/* Header */}
//         <div className="flex items-center justify-between">
//           <div className="flex items-center space-x-3">
//             <div>
//               <button
//                 onClick={handleCancel}
//                 className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors duration-200"
//                 disabled={isLoading}
//               >
//                 <ArrowLeft className="h-5 w-5" />
//               </button>
//               <h2 className="text-xl font-semibold text-gray-900">Ajouter un nouvel utilisateur</h2>
//               {!user.organization['canAddUsers'] && (
//                 <p className="text-sm font-semibold text-red-900">Vous avez atteint votre nombre maximum d'utilisateurs</p> 
//               )}
//             </div>

//             </div>
//         </div>

//         {/* Form */}
//         <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
//           <form onSubmit={handleSubmit} className="p-6 space-y-6">
//             {/* Name Fields Row */}
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               {/* First Name */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   <User className="w-4 h-4 inline mr-2" />
//                   Prénom <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.firstName}
//                   onChange={(e) => handleInputChange('firstName', e.target.value)}
//                   placeholder="Entrer le prénom..."
//                   className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${
//                     errors.firstName ? 'border-red-300 bg-red-50' : 'border-gray-300'
//                   }`}
//                   required
//                   disabled={isLoading}
//                 />
//                 {errors.firstName && (
//                   <p className="mt-1 text-sm text-red-600">{errors.firstName}</p>
//                 )}
//               </div>

//               {/* Last Name */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   <User className="w-4 h-4 inline mr-2" />
//                   Nom de famille <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.lastName}
//                   onChange={(e) => handleInputChange('lastName', e.target.value)}
//                   placeholder="Entrer le nom de famille..."
//                   className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${
//                     errors.lastName ? 'border-red-300 bg-red-50' : 'border-gray-300'
//                   }`}
//                   required
//                   disabled={isLoading}
//                 />
//                 {errors.lastName && (
//                   <p className="mt-1 text-sm text-red-600">{errors.lastName}</p>
//                 )}
//               </div>
//             </div>

//             {/* Contact and Email Row */}
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               {/* Contact */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   <Phone className="w-4 h-4 inline mr-2" />
//                   Contact <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="tel"
//                   value={formData.contact}
//                   onChange={(e) => handleInputChange('contact', e.target.value)}
//                   placeholder="Entrer le numéro de contact..."
//                   className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${
//                     errors.contact ? 'border-red-300 bg-red-50' : 'border-gray-300'
//                   }`}
//                   required
//                   disabled={isLoading}
//                 />
//                 {errors.contact && (
//                   <p className="mt-1 text-sm text-red-600">{errors.contact}</p>
//                 )}
//               </div>

//               {/* Email */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   <Mail className="w-4 h-4 inline mr-2" />
//                   Email <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="email"
//                   value={formData.email}
//                   onChange={(e) => handleInputChange('email', e.target.value)}
//                   placeholder="Entrer l'adresse email..."
//                   className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${
//                     errors.email ? 'border-red-300 bg-red-50' : 'border-gray-300'
//                   }`}
//                   required
//                   disabled={isLoading}
//                 />
//                 {errors.email && (
//                   <p className="mt-1 text-sm text-red-600">{errors.email}</p>
//                 )}
//               </div>
            

//               {/* Role/ Function */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   <UserCheck2Icon className="w-4 h-4 inline mr-2" />
//                   Rôle/fonction <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.role_function}
//                   onChange={(e) => handleInputChange('role_function', e.target.value)}
//                   placeholder="Entrer l'adresse email..."
//                   className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${
//                     errors.role_function ? 'border-red-300 bg-red-50' : 'border-gray-300'
//                   }`}
//                   required
//                   disabled={isLoading}
//                 />
//                 {errors.role_function && (
//                   <p className="mt-1 text-sm text-red-600">{errors.role_function}</p>
//                 )}
//               </div>
//             </div>

//             {/* Password Fields Row */}
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               {/* Password */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   <Lock className="w-4 h-4 inline mr-2" />
//                   Mot de passe <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="password"
//                   value={formData.password}
//                   onChange={(e) => handleInputChange('password', e.target.value)}
//                   placeholder="Entrer le mot de passe..."
//                   className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${
//                     errors.password ? 'border-red-300 bg-red-50' : 'border-gray-300'
//                   }`}
//                   required
//                   disabled={isLoading}
//                 />
//                 {errors.password && (
//                   <p className="mt-1 text-sm text-red-600">{errors.password}</p>
//                 )}
//               </div>

//               {/* Confirm Password */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   <Lock className="w-4 h-4 inline mr-2" />
//                   Confirmer le mot de passe <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="password"
//                   value={formData.confirmPassword}
//                   onChange={(e) => handleInputChange('confirmPassword', e.target.value)}
//                   placeholder="Confirmer le mot de passe..."
//                   className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${
//                     errors.confirmPassword ? 'border-red-300 bg-red-50' : 'border-gray-300'
//                   }`}
//                   required
//                   disabled={isLoading}
//                 />
//                 {errors.confirmPassword && (
//                   <p className="mt-1 text-sm text-red-600">{errors.confirmPassword}</p>
//                 )}
//               </div>
//             </div>

//             {/* Form Actions */}
//             <div className="flex items-center justify-end space-x-4 pt-6 border-t border-gray-200">
//               <button
//                 type="button"
//                 onClick={handleCancel}
//                 className="px-6 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
//                 disabled={isLoading}
//               >
//                 Annuler
//               </button>
//               {user.organization['canAddUsers'] && (
//                 <button
//                   type="submit"
//                   disabled={isLoading}
//                   className="flex items-center px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200"
//                 >
//                   {isLoading ? (
//                     <>
//                       <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
//                       Création en cours...
//                     </>
//                   ) : (
//                     <>
//                       <Save className="h-4 w-4 mr-2" />
//                       Enregistrer l'utilisateur
//                     </>
//                   )}
//                 </button> 
//             )}
//             </div>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// }



import React, { useContext, useState, useEffect } from 'react';
import { Save, X, ArrowLeft, User, Mail, Phone, Lock, UserPlus, UserCheck2Icon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../../../context/AuthContext';
import { useToast } from '../../../../context/ToastContext';
import Loader from '../../../../components/Loader';
import userService from '../../../../services/userService';


export default function AddUser() {
  const { user,hasRole, authTokens } = useContext(AuthContext);
  const { showError, showSuccess } = useToast();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    contact: '',
    email: '',
    role_function:'',
    userType: 'audit', // default value
    password: '',
    confirmPassword: ''
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');



  // Clear errors when component unmounts
  useEffect(() => {
    return () => {
      setErrors({});
    };
  }, []);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.firstName.trim()) {
      newErrors.firstName = 'Le prénom est requis';
    }
    
    if (!formData.lastName.trim()) {
      newErrors.lastName = 'Le nom de famille est requis';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'L\'email est requis';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Format d\'email invalide';
    }
    
    if (!formData.contact.trim()) {
      newErrors.contact = 'Le contact est requis';
    }

    if (!formData.role_function.trim()) {
      newErrors.role_function = 'Le role est requis';
    }

    if (!formData.userType) {
      newErrors.userType = 'Le type d\'utilisateur est requis';
    }
    
    if (!formData.password) {
      newErrors.password = 'Le mot de passe est requis';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Le mot de passe doit contenir au moins 6 caractères';
    }
    
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Les mots de passe ne correspondent pas';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    // Check admin and organization permissions
    if (!user || !authTokens?.access || !user.organization || !hasRole("Admin")) {
      showError("Vous n'avez pas les droits nécessaires pour créer un utilisateur.");
      return;
    }

    // Start loading
    setIsLoading(true);
    setLoadingMessage('Création de l\'utilisateur en cours...');

    try {
      // Prepare user data
      const newUserData = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        contact: formData.contact,
        email: formData.email,
        role_function: formData.role_function,
        user_type: formData.userType,
        password: formData.password
      };

      // Call the service
      const result = await userService.createUser(newUserData, authTokens.access);
      console.log(result)

      if(!result.ok){
        showError(result.error);
      }

      if (result.success) {
        console.log('User created successfully:', result.data);
        
        // Show success message
        showSuccess('Utilisateur créé avec succès !');

        // Reset form after success
        setFormData({
          firstName: '',
          lastName: '',
          contact: '',
          email: '',
          role_function:'',
          userType: 'audit',
          password: '',
          confirmPassword: ''
        });
        setErrors({});

        // Navigate back to user management after a short delay
        setTimeout(() => {
          navigate('/dashboard/admin/users'); // Adjust this path as needed
        }, 2000);

      } else {
        console.error('Error creating user:', result.errorData);
        
        // Handle different error types
        let errorMessage = 'Erreur lors de la création de l\'utilisateur';
        
        if (result.status === 400) {
          // Handle validation errors from backend
          if (result.errorData && typeof result.errorData === 'object') {
            // Check for specific field errors
            if (result.errorData.email) {
              errorMessage = `Email: ${Array.isArray(result.errorData.email) ? result.errorData.email[0] : result.errorData.email}`;
            } else if (result.errorData.password) {
              errorMessage = `Mot de passe: ${Array.isArray(result.errorData.password) ? result.errorData.password[0] : result.errorData.password}`;
            } else if (result.errorData.detail) {
              errorMessage = result.errorData.detail;
            }
          }
        } else if (result.status === 403) {
          errorMessage = result.error || 'Vous n\'avez pas les droits nécessaires pour cette action';
        } else if (result.status === 401) {
          errorMessage = result.error || 'Session expirée. Veuillez vous reconnecter';
        } else if (result.status === 500) {
          errorMessage = result.error || 'Erreur de connexion. Vérifiez votre connexion internet';
        } else if (result.status === 0) {
          errorMessage =  result.error || 'Erreur de connexion. Vérifiez votre connexion internet';
        }
        
        showError(errorMessage);
      }

    } catch (error) {
      console.error('Unexpected error:', error);
      showError("Erreur inattendue. Veuillez réessayer.");
    } finally {
      setIsLoading(false);
      setLoadingMessage('');
    }
  };

  const handleCancel = () => {
    setFormData({
      firstName: '',
      lastName: '',
      contact: '',
      email: '',
      role_function:'',
      userType: 'audit',
      password: '',
      confirmPassword: ''
    });
    setErrors({});
    navigate('/dashboard/admin/users'); // Adjust this path as needed
  };

  return (
    <>
      {/* Loader overlay */}
      <Loader 
        isVisible={isLoading}
        message={loadingMessage}
        type="creation"
        variant="spinner"
        size="medium"
        overlay={true}
      />

      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div>
              <button
                onClick={handleCancel}
                className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors duration-200"
                disabled={isLoading}
              >
                <ArrowLeft className="h-5 w-5" />
              </button>
              <h2 className="text-xl font-semibold text-gray-900">Ajouter un nouvel utilisateur</h2>
              {!user.organization['canAddUsers'] && (
                <p className="text-sm font-semibold text-red-900">Vous avez atteint votre nombre maximum d'utilisateurs</p> 
              )}
            </div>

            </div>
        </div>

        {/* Form */}
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
          <form onSubmit={handleSubmit} className="p-6 space-y-6">
            {/* Name Fields Row */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* First Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <User className="w-4 h-4 inline mr-2" />
                  Prénom <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={formData.firstName}
                  onChange={(e) => handleInputChange('firstName', e.target.value)}
                  placeholder="Entrer le prénom..."
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${
                    errors.firstName ? 'border-red-300 bg-red-50' : 'border-gray-300'
                  }`}
                  required
                  disabled={isLoading}
                />
                {errors.firstName && (
                  <p className="mt-1 text-sm text-red-600">{errors.firstName}</p>
                )}
              </div>

              {/* Last Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <User className="w-4 h-4 inline mr-2" />
                  Nom de famille <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={formData.lastName}
                  onChange={(e) => handleInputChange('lastName', e.target.value)}
                  placeholder="Entrer le nom de famille..."
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${
                    errors.lastName ? 'border-red-300 bg-red-50' : 'border-gray-300'
                  }`}
                  required
                  disabled={isLoading}
                />
                {errors.lastName && (
                  <p className="mt-1 text-sm text-red-600">{errors.lastName}</p>
                )}
              </div>
            </div>

            {/* Contact and Email Row */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Contact */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <Phone className="w-4 h-4 inline mr-2" />
                  Contact <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  value={formData.contact}
                  onChange={(e) => handleInputChange('contact', e.target.value)}
                  placeholder="Entrer le numéro de contact..."
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${
                    errors.contact ? 'border-red-300 bg-red-50' : 'border-gray-300'
                  }`}
                  required
                  disabled={isLoading}
                />
                {errors.contact && (
                  <p className="mt-1 text-sm text-red-600">{errors.contact}</p>
                )}
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <Mail className="w-4 h-4 inline mr-2" />
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => handleInputChange('email', e.target.value)}
                  placeholder="Entrer l'adresse email..."
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${
                    errors.email ? 'border-red-300 bg-red-50' : 'border-gray-300'
                  }`}
                  required
                  disabled={isLoading}
                />
                {errors.email && (
                  <p className="mt-1 text-sm text-red-600">{errors.email}</p>
                )}
              </div>
            </div>

            {/* Role/Function and User Type Row */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Role/ Function */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <UserCheck2Icon className="w-4 h-4 inline mr-2" />
                  Rôle/fonction <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={formData.role_function}
                  onChange={(e) => handleInputChange('role_function', e.target.value)}
                  placeholder="Entrer le rôle/fonction..."
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${
                    errors.role_function ? 'border-red-300 bg-red-50' : 'border-gray-300'
                  }`}
                  required
                  disabled={isLoading}
                />
                {errors.role_function && (
                  <p className="mt-1 text-sm text-red-600">{errors.role_function}</p>
                )}
              </div>

              {/* User Type */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <UserPlus className="w-4 h-4 inline mr-2" />
                  Type d'utilisateur <span className="text-red-500">*</span>
                </label>
                <div className="space-y-3 pt-2">
                  <div className="flex items-center">
                    <input
                      type="radio"
                      id="audit"
                      name="userType"
                      value="audit"
                      checked={formData.userType === 'audit'}
                      onChange={(e) => handleInputChange('userType', e.target.value)}
                      className="w-4 h-4 text-teal-600 border-gray-300 focus:ring-teal-500"
                      disabled={isLoading}
                    />
                    <label htmlFor="audit" className="ml-3 text-sm text-gray-700 cursor-pointer">
                      Audit management user
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="radio"
                      id="risk"
                      name="userType"
                      value="risk"
                      checked={formData.userType === 'risk'}
                      onChange={(e) => handleInputChange('userType', e.target.value)}
                      className="w-4 h-4 text-teal-600 border-gray-300 focus:ring-teal-500"
                      disabled={isLoading}
                    />
                    <label htmlFor="risk" className="ml-3 text-sm text-gray-700 cursor-pointer">
                      Risk management user
                    </label>
                  </div>
                </div>
                {errors.userType && (
                  <p className="mt-1 text-sm text-red-600">{errors.userType}</p>
                )}
              </div>
            </div>

            {/* Password Fields Row */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Password */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <Lock className="w-4 h-4 inline mr-2" />
                  Mot de passe <span className="text-red-500">*</span>
                </label>
                <input
                  type="password"
                  value={formData.password}
                  onChange={(e) => handleInputChange('password', e.target.value)}
                  placeholder="Entrer le mot de passe..."
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${
                    errors.password ? 'border-red-300 bg-red-50' : 'border-gray-300'
                  }`}
                  required
                  disabled={isLoading}
                />
                {errors.password && (
                  <p className="mt-1 text-sm text-red-600">{errors.password}</p>
                )}
              </div>

              {/* Confirm Password */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <Lock className="w-4 h-4 inline mr-2" />
                  Confirmer le mot de passe <span className="text-red-500">*</span>
                </label>
                <input
                  type="password"
                  value={formData.confirmPassword}
                  onChange={(e) => handleInputChange('confirmPassword', e.target.value)}
                  placeholder="Confirmer le mot de passe..."
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${
                    errors.confirmPassword ? 'border-red-300 bg-red-50' : 'border-gray-300'
                  }`}
                  required
                  disabled={isLoading}
                />
                {errors.confirmPassword && (
                  <p className="mt-1 text-sm text-red-600">{errors.confirmPassword}</p>
                )}
              </div>
            </div>

            {/* Form Actions */}
            <div className="flex items-center justify-end space-x-4 pt-6 border-t border-gray-200">
              <button
                type="button"
                onClick={handleCancel}
                className="px-6 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isLoading}
              >
                Annuler
              </button>
              {user.organization['canAddUsers'] && (
                <button
                  type="submit"
                  disabled={isLoading}
                  className="flex items-center px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200"
                >
                  {isLoading ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                      Création en cours...
                    </>
                  ) : (
                    <>
                      <Save className="h-4 w-4 mr-2" />
                      Enregistrer l'utilisateur
                    </>
                  )}
                </button> 
            )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
}